import PropTypes from "prop-types";

const STATUS_BADGES = {
  connected: {
    wrap: "bg-emerald-50 text-emerald-700 ring-emerald-200",
    dot: "bg-emerald-500",
    label: "Connected",
    pulse: false,
  },
  pairing: {
    wrap: "bg-indigo-50 text-indigo-700 ring-indigo-200",
    dot: "bg-indigo-500",
    label: "Pairing",
    pulse: true,
  },
  sync_failed: {
    wrap: "bg-amber-50 text-amber-800 ring-amber-200",
    dot: "bg-amber-500",
    label: "Needs sync",
    pulse: false,
  },
  unpaired: {
    wrap: "bg-slate-100 text-slate-600 ring-slate-200",
    dot: "bg-slate-400",
    label: "Not connected",
    pulse: false,
  },
  error: {
    wrap: "bg-rose-50 text-rose-700 ring-rose-200",
    dot: "bg-rose-500",
    label: "Error",
    pulse: false,
  },
  seeding: {
    wrap: "bg-indigo-50 text-indigo-700 ring-indigo-200",
    dot: "bg-indigo-500",
    label: "Seeding",
    pulse: true,
  },
  not_seeded: {
    wrap: "bg-amber-50 text-amber-700 ring-amber-200",
    dot: "bg-amber-500",
    label: "Coming soon",
    pulse: false,
  },
  coming_soon: {
    wrap: "bg-amber-50 text-amber-700 ring-amber-200",
    dot: "bg-amber-500",
    label: "Coming soon",
    pulse: false,
  },
};

function StatusBadgeSpan({ wrap, dot, label, pulse }) {
  return (
    <span className={`inline-flex items-center gap-1 rounded-full ring-1 px-1.5 py-0.5 text-[10px] font-semibold ${wrap}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${dot}${pulse ? " animate-pulse" : ""}`} />
      {label}
    </span>
  );
}

StatusBadgeSpan.propTypes = {
  wrap: PropTypes.string.isRequired,
  dot: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  pulse: PropTypes.bool.isRequired,
};

export function ConnectionStatusBadge({ status }) {
  const config = STATUS_BADGES[status];
  if (config) {
    return <StatusBadgeSpan {...config} />;
  }
  return (
    <StatusBadgeSpan
      wrap="bg-slate-100 text-slate-600 ring-slate-200"
      dot="bg-slate-400"
      label={status}
      pulse={false}
    />
  );
}

ConnectionStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
};
